
import React, { useState, useEffect } from "react";
import claraviewLogo from "../../../assets/claraViewMedia/claraview-logo.png"

const Loader = ({ text }) => {
    const [progress, setProgress] = useState(0);
    const [showTagline, setShowTagline] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prevProgress) => {
                if (prevProgress >= 100) {
                    clearInterval(interval);
                    setShowTagline(true);
                    return 100;
                }
                return prevProgress + 1;
            });
        }, 100);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className=" h-dvh top-0 left-0 flex flex-col items-center justify-center font-novatica">
            <div className="w-48 h-48 flex items-center justify-center">
                <img src={claraviewLogo} alt="" className=" h-40 object-contain" />
            </div>
            <div className="w-64 mt-4">
                <div className="h-2 bg-gray-200 rounded-full">
                    <div
                        className="h-2 bg-gradient-to-r from-[#37392E] to-[#BED0C5]  rounded-full"
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
            </div>
            <p className="text-xl font-semibold mt-2">{`${progress}%`}</p>
            <p className="text-lg text-[#2C2D24] mt-1">{text || "Rendering What's Possible"}</p>
            {showTagline && (
                <p className="text-lg mt-4 text-green-500 animate-pulse">
                    Get ready to be amazed!
                </p>
            )}
        </div>
    );
};

export default Loader;
